import { Module } from 'vuex'
import axios from 'axios'
import { Marketplace } from '@/shared/enums/marketplace'
import { MarketplaceInfo } from '@/shared/model/marketplace.model'

interface MarketplaceState {
  selected: Marketplace | '';
  all: Marketplace[];
  selectedInfo: MarketplaceInfo;
}

export const LS_KEY_SELECTED = 'mcmc-selected-marketplace'

export const marketplaceStore: Module<MarketplaceState, any> = {
  state: {
    selected: '',
    all: [],
    selectedInfo: {
      siteKey: '',
      siteSecret: '',
    },
  },
  mutations: {
    selectMarketplace (state, newMarketplace: Marketplace): void {
      window.localStorage.setItem(LS_KEY_SELECTED, newMarketplace)
      state.selected = newMarketplace
    },
    setAllMarketplaces (state, marketplacesList: Marketplace[]): void {
      state.all = marketplacesList
    },
    setMarketplaceInfo (state, newInfo: MarketplaceInfo): void {
      state.selectedInfo = newInfo
    },
  },
  actions: {
    getAllMarketplaces ({ commit }): void {
      axios
        .get('api/marketplaces')
        .then(response => {
          commit('setAllMarketplaces', response.data)
        })
        .catch(error => {
          console.error(error)
          commit('setAllMarketplaces', [])
        })
    },
    getMarketplaceInfo ({ commit, state }): Promise<void> {
      if (!state.selected) {
        return
      }
      return axios
        .get(`api/marketplaces/${state.selected}`)
        .then(response => {
          commit('setMarketplaceInfo', response.data)
        })
        .catch(error => {
          console.log('MSG: getMarketplaceInfo -> error', error)
          return Promise.reject(error)
        })
    },
  },
}
